import { IconFontSize } from '@/shared/types/types';

export const sizeMap: Record<IconFontSize | 'none', number> = {
  none: 0,
  xs: 10,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
};

export const backgroundSizeValues: Record<string, string> = {
  xxs: 'ui-p-4',
  xs: 'ui-p-6',
  sm: 'ui-p-4',
  md: 'ui-p-8',
  lg: 'ui-p-12',
  xl: 'ui-p-16',
};

export const paddingValues: Record<string, string> = {
  none: '',
  xxs: 'ui-p-2',
  xs: 'ui-p-4',
  sm: 'ui-p-8',
  md: 'ui-p-12',
  lg: 'ui-p-16',
  xl: 'ui-p-20',
  '2xl': 'ui-p-24',
};
